/**
 * Segment integration name
 */
export const SEGMENT_INTEGRATION_NAME = 'Segment.io';

/**
 * HTTPS protocol constant
 */
export const HTTPS_PROTOCOL = 'https';

/**
 * Segment consent event name
 */
export const SEGMENT_CONSENT_EVENT = 'Segment Consent Preference Updated';
